import { StyleProp, View, ViewStyle } from 'react-native';

import { ActionSheet, Skeleton, SkeletonTextBlock, createMqStyles, tokens } from '@fhs/ui';

import { BottomButtonContainer } from '../../screens/offer-guide/bottom-button';

export function ChallengeDetailsSkeleton({ style }: { style?: StyleProp<ViewStyle> }) {
  const styles = useMqStyles();

  return (
    <View style={[styles.container, style]}>
      <ActionSheet.ScrollView style={styles.scrollView}>
        <View style={styles.imageContainer}>
          <Skeleton style={styles.image} />
        </View>
        <View style={{ paddingHorizontal: 16 }}>
          <SkeletonTextBlock lines={2} style={styles.titleContainer} lineStyle={{ height: 24 }} />
          <SkeletonTextBlock lines={1} style={styles.descriptionContainer} />
          <SkeletonTextBlock
            lines={1}
            style={styles.howItWorksTitleContainer}
            lineStyle={{ height: 24 }}
          />
          <SkeletonTextBlock lines={3} style={styles.howItWorksContainer} />
          <Skeleton style={styles.stepsContainer} />
          <View style={styles.divider} />
          <SkeletonTextBlock lines={3} style={styles.termsContainer} />
        </View>
      </ActionSheet.ScrollView>

      <BottomButtonContainer>
        <Skeleton style={styles.skeletonButton} />
      </BottomButtonContainer>
    </View>
  );
}
const useMqStyles = createMqStyles({
  imageContainer: {
    $base: {
      width: '100%',
      aspectRatio: 5 / 2,
    },
  },
  image: {
    $base: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      backgroundColor: tokens.colors.$black10,
      borderBottomWidth: 1,
      borderBottomColor: tokens.colors.$black10,
    },
  },
  container: {
    $base: {
      flex: 1,
    },
  },
  scrollView: {
    $base: {
      flex: 1,
    },
  },
  titleContainer: {
    $base: {
      paddingTop: 20,
    },
    $gteDesktop: {
      paddingTop: 28,
    },
  },
  descriptionContainer: {
    $base: {
      width: '35%',
      marginTop: 12,
    },
  },
  howItWorksTitleContainer: {
    $base: {
      width: '25%',
      marginTop: 20,
    },
    $gteDesktop: {
      marginTop: 28,
    },
  },
  howItWorksContainer: {
    $base: {
      width: '100%',
      marginTop: 8,
    },
  },
  stepsContainer: {
    $base: {
      height: 135,
      borderRadius: 4,
      marginTop: 16,
    },
  },
  divider: {
    $base: {
      height: 1,
      width: '100%',
      backgroundColor: tokens.colors.$blackOpacity10,
      marginTop: 20,
    },
  },
  termsContainer: {
    $base: {
      width: '100%',
      marginVertical: 20,
    },
  },
  skeletonButton: {
    $base: {
      height: 48,
    },
  },
  footer: {
    $base: {
      borderTopWidth: 1,
      borderTopColor: tokens.colors.$blackOpacity10,
      alignItems: 'center',
      padding: 16,
    },
    $gteDesktop: {
      padding: 28,
    },
  },
});
